export default "/assets/images/mila-feed-11.55d576c31a4f0a2b.mp4";